export type Runtime = "localhost" | "staging" | "production"


import queryString from 'query-string';

export const isLocalhost = (): boolean => window.location.host === 'localhost:3000';

export const getRunEnv = (): Runtime => {
    if (isLocalhost())
        return "localhost"
    else if (window.location.host.includes("staging"))
        return "staging"
    else if (window.location.host.includes("app"))
        return "production"
    else
        throw new Error("unexpected app environment")
}

export const isRunEnvProd = (): boolean => getRunEnv() === "production" ? true : false


/** used for disabling map render */
export const isAllowedByOptions = (): boolean =>
    (isLocalhost() && queryString.parse(window.location.search)['map'] !== undefined) ||
    (!isLocalhost() && queryString.parse(window.location.search)['nomap'] === undefined);

